import * as React from 'react';

const TBody: React.FC<any> = ({ children }) => <tbody>{children}</tbody>;

export default TBody;
